import { ref, computed } from "vue";
import { RenrakuForList } from "@/types/KaisyaRenraku";
import { RenrakuService } from "@/service/RenrakuService";

/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(1); // APIで読み込みをする本数
  const isError = ref(false);

  const form = ref<RenrakuForList[]>([]);

  // ログインユーザーに関連する会社連絡で既読以外を取得する
  const srv = new RenrakuService();

  srv.getRenrakuList().then(res => {
    if (res) {
      // 成功したらロード数をデクリメント
      loading.value--;
    } else {
      // エラー
      isError.value = true;
    }
    // とりあえず代入はする
    form.value = res;
  });

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  });

  return {
    isLoading,
    isError,
    form,
  }
}
